__turbopack_context__.v({
  "below": "LCatalogTwoColsLeft-module__wAEf6G__below",
  "content": "LCatalogTwoColsLeft-module__wAEf6G__content",
  "mainColumn": "LCatalogTwoColsLeft-module__wAEf6G__mainColumn",
  "root": "LCatalogTwoColsLeft-module__wAEf6G__root",
  "sidebar": "LCatalogTwoColsLeft-module__wAEf6G__sidebar",
});
